import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import Badge from 'components/base/Badge';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import FeatherIcon from 'feather-icons-react';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { errorHandler } from 'helpers/response-utils';

export const ClinicTableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Clinic Name',
    cell: ({ row: { original } }) => {
      const { name, status, id } = original;
      const type = 'info';
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to={'/superadmin/clinic/edit/' + id} className="fs-8 fw-bold">
              {name}
            </Link>
            <div className="d-flex align-items-center">
              <Badge variant="phoenix" bg={type}>
                {status}
              </Badge>
            </div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: '25%' },
        className: 'ps-4 pe-5 border-start border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap ps-4 pe-5 border-start border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'code',
    header: 'Code',
    cell: ({ row: { original } }) => {
      const { code } = original;
      const type = 'info';
      return (
        <div className="d-flex align-items-center">
          <div>{code}</div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: '25%' },
        className: 'ps-4 pe-5 border-start border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap ps-4 pe-5 border-start border-end border-translucent'
      }
    }
  },
  {
    id: 'headDietitian',
    header: 'Head Dietitian',
    cell: ({ row: { original } }) => {
      const firstname = original.user?.firstname || '-';
      return <span className="fw-semibold">{firstname}</span>;
    },
    meta: {
      headerProps: {
        style: { width: '18%', minWidth: '150px' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    id: 'headDietitianEmail',
    header: 'Head Dietitian Email',
    cell: ({ row: { original } }) => {
      const email = original.user?.email || '-';
      if (email === '-') {
        return <span>{email}</span>;
      }
      return (
        <Link className="text-body-highlight" to={`mailto:${email}`}>
          {email}
        </Link>
      );
    },
    meta: {
      headerProps: {
        style: { width: '20%', minWidth: '180px' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'createdAt',
    header: 'Create date',
    cell: ({ row: { original } }) => original.createdAt,
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-4 pe-5'
      },
      cellProps: {
        className: 'white-space-nowrap ps-4 text-body-tertiary'
      }
    }
  },
  {
    accessorKey: 'status',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-info-subtle rounded me-2">
            <FeatherIcon icon="user" size={16} className="text-info-dark" />
          </div>
          <span>Status</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => original.status,
    meta: {
      headerProps: {
        style: { width: '15%', minWidth: '150px' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    id: 'leadDropdown',
    cell: ({ row: { original } }) => {
      const token = localStorage.getItem('token');

      const deleteReacod = async (id: number) => {
        const response = await axios.delete(
          `${process.env.REACT_APP_ENDPOINT}/clinic/sa/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (response.data['status'] == false) {
          errorHandler(response.data);
          return false;
        }
        handleClose();
        window.location.reload();
      };

      const [show, setShow] = useState(false);

      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <Dropdown.Item href={'/superadmin/clinic/edit/' + original.id}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={handleShow} className="text-danger">
                Remove
              </Dropdown.Item>
            </RevealDropdown>
          </RevealDropdownTrigger>

          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this clinic?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button
                variant="primary"
                onClick={() => deleteReacod(original.id)}
              >
                Yes delete
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      },
      cellProps: {
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      }
    }
  }
];

const ClinicTable = () => {
  return (
    <div>
      <AdvanceTable
        tableProps={{
          className: 'phoenix-table fs-9 border-top border-translucent'
        }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default ClinicTable;
